var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Prop, Component, Watch, Mixins } from 'vue-property-decorator';
import { OtherOperation } from '@/common/types/OtherOperation';
import { Financing } from '@/common/types/Financing';
import PlainTextControl from '@/common/components/PlainTextControl.vue';
import SingleSelectTableCell from '@/common/components/SingleSelectTableCell.vue';
import TextAreaControl from '@/common/components/TextAreaControl.vue';
import RadioButtonRow from "@/common/components/RadioButtonRow.vue";
import DateInputRow from '@/common/components/DateInputRow.vue';
import NumericInputControl from '@/common/components/NumericInputControl.vue';
import TooltipIcon from '@/common/components/TooltipIcon.vue';
import { parseString, absoluteMinimumDate, absoluteMaximumDate } from '@/common/utils/dateUtilities';
import { Savable } from '@/common/mixins/Savable';
import { Focusable } from '@/common/mixins/Focusable';
var OtherOperationControl = /** @class */ (function (_super) {
    __extends(OtherOperationControl, _super);
    function OtherOperationControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.indexmodified = "";
        _this.radioButtonValueChanged = "";
        return _this;
    }
    OtherOperationControl.prototype.onPropertyChanged = function () {
        if (!this.otherOperation.hasOtherOperation) {
            if (this.otherOperation.items.length > 1 || (this.otherOperation.items.length == 1 && this.firstOperationNotEmpty(this.otherOperation.items[0]))) {
                if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.OtherOperation").toString())) {
                    this.otherOperation.items = [];
                }
                else {
                    this.otherOperation.hasOtherOperation = true;
                    this.radioButtonValueChanged = Date();
                }
            }
            else if (this.otherOperation.items.length == 1) {
                this.otherOperation.items = [];
            }
        }
        if (this.otherOperation.hasOtherOperation && this.otherOperation.items.length === 0) {
            this.addNewRow(false);
        }
    };
    OtherOperationControl.prototype.firstOperationNotEmpty = function (item) {
        if ((item.aidAmount || item.aidAmount == 0)
            || item.endTime
            || item.financing
            || (item.revenue || item.revenue == 0)
            || item.specifier
            || item.startTime)
            return true;
        return false;
    };
    Object.defineProperty(OtherOperationControl.prototype, "financingOptions", {
        get: function () {
            return [
                { id: Financing.ServiceProduction, name: "AidApplication.BasicInfo.OtherOperation.Items.Financing.ServiceProduction" },
                { id: Financing.MinistryOfSocialAffairsAndHealth, name: "AidApplication.BasicInfo.OtherOperation.Items.Financing.MinistryOfSocialAffairsAndHealth" },
                { id: Financing.MinistryOfEductionAndCulture, name: "AidApplication.BasicInfo.OtherOperation.Items.Financing.MinistryOfEductionAndCulture" },
                { id: Financing.EuropianSocialFund, name: "AidApplication.BasicInfo.OtherOperation.Items.Financing.EuropianSocialFund" },
                { id: Financing.Other, name: "AidApplication.BasicInfo.OtherOperation.Items.Financing.Other" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    OtherOperationControl.prototype.clearEndDateIfNeeded = function (operation) {
        if (operation.financing === Financing.ServiceProduction) {
            operation.endTime = null;
        }
    };
    OtherOperationControl.prototype.isServiceProduction = function (operation) {
        if (operation.financing === Financing.ServiceProduction)
            return true;
        return false;
    };
    Object.defineProperty(OtherOperationControl.prototype, "showOtherOperationDetails", {
        get: function () {
            return this.otherOperation.hasOtherOperation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OtherOperationControl.prototype, "showDeleteBtn", {
        get: function () {
            return (this.otherOperation.items
                && this.otherOperation.items.length > 1) && !this.isReadOnly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OtherOperationControl.prototype, "isAddNewRowDisabled", {
        get: function () {
            return this.otherOperation.items.length >= 25;
        },
        enumerable: false,
        configurable: true
    });
    OtherOperationControl.prototype.isAidAmountReadOnly = function (item) {
        var typeOtherAndHasRevenue = item.financing === Financing.Other && item.revenue != null;
        if (item.financing === Financing.ServiceProduction || typeOtherAndHasRevenue)
            item.aidAmount = null;
        return this.isReadOnly || item.financing === Financing.ServiceProduction || typeOtherAndHasRevenue;
    };
    OtherOperationControl.prototype.isRevenueReadOnly = function (item) {
        var typeOtherAndHasAidAmount = item.financing === Financing.Other && item.aidAmount != null;
        if ((item.financing !== Financing.ServiceProduction && item.financing !== Financing.Other) || typeOtherAndHasAidAmount)
            item.revenue = null;
        return this.isReadOnly || (item.financing !== Financing.ServiceProduction && item.financing !== Financing.Other) || typeOtherAndHasAidAmount;
    };
    OtherOperationControl.prototype.addNewRow = function (focus) {
        return __awaiter(this, void 0, void 0, function () {
            var item, targetId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        item = { specifier: null, financing: null, startTime: null, endTime: null, aidAmount: null, revenue: null };
                        this.otherOperation.items.push(item);
                        this.forceSave();
                        if (!focus) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        targetId = "financingoptions_" + this.otherOperation.items.length;
                        this.focusOnComponentId(targetId);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    OtherOperationControl.prototype.deleteRow = function (index) {
        if (confirm(this.$i18n.t("Confirmation.DeleteRow").toString())) {
            this.otherOperation.items.splice(index, 1);
            this.forceSave();
            this.indexmodified = Date();
        }
    };
    Object.defineProperty(OtherOperationControl.prototype, "minDate", {
        get: function () {
            return parseString(absoluteMinimumDate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OtherOperationControl.prototype, "maxDate", {
        get: function () {
            return parseString(absoluteMaximumDate);
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof OtherOperation !== "undefined" && OtherOperation) === "function" ? _a : Object)
    ], OtherOperationControl.prototype, "otherOperation", void 0);
    __decorate([
        Watch("otherOperation.hasOtherOperation"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], OtherOperationControl.prototype, "onPropertyChanged", null);
    OtherOperationControl = __decorate([
        Component({
            name: "OtherOperationControl",
            components: {
                PlainTextControl: PlainTextControl,
                SingleSelectTableCell: SingleSelectTableCell,
                TextAreaControl: TextAreaControl,
                RadioButtonRow: RadioButtonRow,
                DateInputRow: DateInputRow,
                NumericInputControl: NumericInputControl,
                TooltipIcon: TooltipIcon
            }
        })
    ], OtherOperationControl);
    return OtherOperationControl;
}(Mixins(Savable, Focusable)));
export default OtherOperationControl;
